<template>
    <div class="container h-100 d-flex align-items-lg-center">
        <b-card no-body class="card-success-garden-help mx-auto">
            <b-card-header>
                <font-awesome-icon icon="fa-solid fa-check" />
            </b-card-header>
            <b-card-title>
                Payment Success
            </b-card-title>
            <b-card-body class="mb-5">
                <b-card-text>
                    Thank for your payment.
                </b-card-text>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>

import axios from "axios";

export default {
    name: "GardenHelpSuccessPayment",
    components: {
    },
    data() {
        return {
        }
    }
}
</script>
<style scoped::v-deep >
@import "../styles/garden-help-button-styles.css";
@import "../styles/garden-help-styles.css";
</style>


// WEBPACK FOOTER //
// src/projects/garden_help/payment/SuccessPayment.vue